// Product gallery hints (snippets/product-gallery.liquid): tells the visitor
// there are more images than fit on screen. Purely presentational - image
// selection, autoplay and strip dragging stay in assets/product-gallery.js.
//
//  - "3 / 8" counter on the main image, read from whichever thumbnail
//    product-gallery.js currently marks aria-current="true".
//  - A fade + arrow on each edge of the thumbnail strip that still has
//    thumbnails scrolled out of view; both vanish at the ends.
(function () {
  document.querySelectorAll('[data-product-gallery]').forEach(function (root) {
    var strip = root.querySelector('[data-gallery-thumbnails]');
    var wrap = root.querySelector('[data-gallery-thumbs-wrap]');
    if (!strip || !wrap) return;

    var thumbs = Array.prototype.slice.call(strip.querySelectorAll('[data-gallery-thumbnail]'));
    if (thumbs.length < 2) return;

    // ---- counter -------------------------------------------------------
    var counter = root.querySelector('[data-gallery-count]');
    function syncCounter() {
      if (!counter) return;
      var active = 0;
      thumbs.forEach(function (thumb, i) {
        if (thumb.getAttribute('aria-current') === 'true') active = i;
      });
      counter.textContent = (active + 1) + ' / ' + thumbs.length;
    }
    if (counter && window.MutationObserver) {
      var observer = new MutationObserver(syncCounter);
      thumbs.forEach(function (thumb) {
        observer.observe(thumb, { attributes: true, attributeFilter: ['aria-current'] });
      });
    }
    syncCounter();

    // ---- edge fades + arrows ------------------------------------------
    var parts = {
      start: wrap.querySelectorAll('[data-thumbs-fade="start"], [data-thumbs-arrow="start"]'),
      end: wrap.querySelectorAll('[data-thumbs-fade="end"], [data-thumbs-arrow="end"]')
    };

    function isRtl() {
      return window.getComputedStyle(strip).direction === 'rtl';
    }

    // Rect-based rather than scrollLeft-based, so it is correct in RTL
    // (where scrollLeft runs 0 -> negative) without any branching on sign.
    function syncEdges() {
      var box = strip.getBoundingClientRect();
      var first = thumbs[0].getBoundingClientRect();
      var last = thumbs[thumbs.length - 1].getBoundingClientRect();
      var rtl = isRtl();
      var moreAtStart = rtl ? first.right > box.right + 2 : first.left < box.left - 2;
      var moreAtEnd = rtl ? last.left < box.left - 2 : last.right > box.right + 2;
      Array.prototype.forEach.call(parts.start, function (el) { el.hidden = !moreAtStart; });
      Array.prototype.forEach.call(parts.end, function (el) { el.hidden = !moreAtEnd; });
    }

    var queued = false;
    function queueSync() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        syncEdges();
      });
    }

    strip.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync);
    window.addEventListener('load', syncEdges);

    Array.prototype.forEach.call(wrap.querySelectorAll('[data-thumbs-arrow]'), function (arrow) {
      arrow.addEventListener('click', function () {
        var forward = arrow.getAttribute('data-thumbs-arrow') === 'end';
        var sign = (forward ? 1 : -1) * (isRtl() ? -1 : 1);
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        strip.scrollBy({ left: sign * strip.clientWidth * 0.75, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    syncEdges();
  });
})();
